"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _selectors = require("settings-ui-sdk/Blogs/selectors");

var _selectors2 = require("settings-ui-sdk/UserSettings/selectors");

var _RequestStatusTypes = _interopRequireWildcard(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _selectors3 = require("settings-ui-sdk/Auth/selectors");

var _constants = require("settings-ui-sdk/UserSettings/constants");

var BlogRedirectContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BlogRedirectContainer, _PureComponent);

  function BlogRedirectContainer() {
    (0, _classCallCheck2.default)(this, BlogRedirectContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlogRedirectContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(BlogRedirectContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.maybeRedirect(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.maybeRedirect(newProps);
    }
  }, {
    key: "maybeRedirect",
    value: function maybeRedirect(props) {
      var fetchBlogsRequestStatus = props.fetchBlogsRequestStatus,
          fetchUserSettingsStatus = props.fetchUserSettingsStatus,
          defaultBlogId = props.defaultBlogId;
      var fetchUserSettingsFinished = fetchUserSettingsStatus === _RequestStatusTypes.default.SUCCEEDED || fetchUserSettingsStatus === _RequestStatusTypes.default.FAILED;

      if (fetchBlogsRequestStatus === _RequestStatusTypes.default.SUCCEEDED && fetchUserSettingsFinished) {
        this.props.push("/website/blogs/" + defaultBlogId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UILoadingSpinner.default, {
        grow: true,
        minHeight: 200
      });
    }
  }]);
  return BlogRedirectContainer;
}(_react.PureComponent);

BlogRedirectContainer.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  fetchBlogsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  defaultBlogId: _react.PropTypes.number,

  /* eslint-enable react/no-unused-prop-types */
  push: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var userId = (0, _selectors3.getUserId)(state);
  return {
    fetchBlogsRequestStatus: (0, _selectors.getFetchBlogsRequestStatus)(state),
    fetchUserSettingsStatus: (0, _selectors2.getFetchUserSettingsRequestStatus)(_constants.BLOG_SETTINGS_NAMESPACE, _constants.USER_SETTINGS_UID, userId)(state),
    defaultBlogId: (0, _selectors.getDefaultBlogId)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push
})(BlogRedirectContainer);

exports.default = _default;
module.exports = exports.default;